const RICOS_VERSION = "10.148.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
